import { setCurrentUser } from "utils/utils"
import { API_ENDPOINT } from "./Api"
import requestInstance from "./Request"

let env = process.env.REACT_APP_API_BASE_URL

export const profileApi = async() => {
    const res = await requestInstance.get(
        `${env}${API_ENDPOINT.Profile.api}`,
    )
    .catch((err) => err.response)
    return setCurrentUser(res)
}

export const updateProfileApi = async(data) => {
    const res = await requestInstance.patch(
        `${env}${API_ENDPOINT.Profile.api}`,data,
        {headers: { 'Content-Type':'appication/x-www-form-urlencoded'}}
    )
    .catch((err) => err.response)
    return setCurrentUser(res)
}

export const verifyProfileOtpApi =  async(data) =>{
    const res = await requestInstance.post(
        `${env}${API_ENDPOINT.Profile.verifyApi}`,data,
    )
    .catch((err) => err.response)
    return setCurrentUser(res)
}